import { Action, ErrorCodes, OperationType, Position, WindowType } from "puzzle";

export const getCompletePreconditionData: Action = [{
  name: 'createWorkflowConfigurationParams',
  type: OperationType.action
}, {
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/jobPhases/' + {submissionData.taskId} + '/workflowConfiguration'",
        params: '{workflowConfigurationParams}'
      }
    },
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'setFlagConfiguration',
  args: ['actionName', 'responseData']
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getMandatoryCommentEnabled',
  mappingName: 'mandatoryCommentEnabled',
  args: ['actionName', 'selectAll'],
  type: OperationType.addOperationData
}, {
  condition: '{mandatoryCommentEnabled}',
  conditionOperations: [{
    condition: '{executionModuleName} === "ActionExecutor"',//todo consider batter solution
    conditionOperations: [{
      data: {
        template: {
          requestDataForPreconditionsCheck: {}
        }
      },
      type: OperationType.data
    }],
    elseOperations: [{
      evaluate: true,
      moduleName: '{executionModuleName}',
      name: 'createRequestParams',
      args: ['selectAll'],
      mappingName: 'requestDataForPreconditionsCheck',
      type: OperationType.addOperationData
    }],
    type: OperationType.conditional
  }, {
    data: {
      template: {
        bind: {
          promoteDemotePreconditionsCheckURL: '"/jobPhases/" + (_.get({selectedSubmissions},`[0].taskId`) || _.get({submissionData},`taskId`)) + "/promoteDemotePreconditionsCheck"'
        }
      }
    },
    type: OperationType.data
  }, {
    data: {
      template: {
        method: 'post',
        bind: {
          url: '{promoteDemotePreconditionsCheckURL}',
          params: '{requestDataForPreconditionsCheck}'
        }
      },
    },
    mappingName: 'mandatoryComments',
    type: OperationType.request //TODO add handleRequestException and not override responseData
  }],
  type: OperationType.conditional
}];

export const createWorkflowConfigurationParams = [{
  condition: '{mandatoryCompleteParams}',
  conditionOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'createRequestParams',
    args: ['selectAll'],
    mappingName: 'workflowConfigurationParams',
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    data: {
      template: {
        workflowConfigurationParams: {}
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}];

export const task_complete_jobPhase_files: Action = [{
  name: 'getCompletePreconditionData',
  type: OperationType.action
}, {
  moduleName: 'ActionExecutor',
  args: [
    'actionName',
    'responseData',
    'ignoreAdditionalValidation',
    'mandatoryComments',
    'skipClaimedCondition',
    'submissionData'
  ],
  name: 'checkIfCompleteCanBeExecuted',
  mappingName: 'canBeExecutedData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        previousPhase: '{responseData.demotionPhase}'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '{canBeExecutedData.canBeExecuted}',
  conditionOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    args: ['actionName', 'mandatoryComments'],
    name: 'setMandatoryCommentsFlag'
  }, {
    persistent: [
      'actionName',
      'executionModuleName',
      'promoteFilesAction',
      'submissionData',
      'selectAll',
      'mandatoryCompleteParams',
      'endpointPrefix',
      'completeSupplierURL',
      'previousPhase'
    ],
    type: OperationType.addPersistentData
  }, {
    name: 'completeActionWarnings',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          actionNameLocale: '{canBeExecutedData.actionParams.actionNameLocale}',
          text: '{canBeExecutedData.actionParams.text}'
        }
      },
    },
    type: OperationType.data
  }, {
    evaluate: true,
    name: '{canBeExecutedData.dispatchAction}',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const completeActionWarnings: Action = [{
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getWarningFlags',
  mappingName: 'warningFlags',
  args: ['actionName'],
  type: OperationType.addOperationData
}, {
  condition: '{warningFlags.flagSum}',
  conditionOperations: [{
    moduleName: 'App',
    type: OperationType.maskModule
  }, {
    condition: '{gsSaveRequestData}',
    conditionOperations: [{
      name: 'saveGradingAndScoringRequest',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'getComment',
    mappingName: 'promoteDemoteComment',
    type: OperationType.addOperationData
  }, {
    condition: '{mandatoryCompleteParams}',
    conditionOperations: [{
      evaluate: true,
      moduleName: '{executionModuleName}',
      name: 'createRequestParams',
      args: ['selectAll'],
      mappingName: 'completeParams',
      type: OperationType.addOperationData
    }],
    elseOperations: [{
      data: {
        template: {
          completeParams: {},
          commentsParams: {
            bind: {
              taskId: '{submissionData.taskId}'
            }
          }
        }
      },
      type: OperationType.data
    }],
    type: OperationType.conditional,
  }, {
    condition: '!!{promoteDemoteComment} && !_.get({gsSaveRequestData}, "commentParams")',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            commentsRequestData: `_.isEmpty({completeParams}) ? {commentsParams} : {completeParams}`
          }
        }
      },
      evaluate: true,
      moduleName: '{executionModuleName}',
      name: 'createCommentsRequestParams',
      args: ['actionName', 'commentsRequestData'],
      mappingName: 'commentsRequestParams',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          method: 'post',
          bind: {
            url: "'/submissions/' + {submissionData.submissionId} + '/comments/add'",
            params: '{commentsRequestParams}'
          }
        },
      },
      mappingName: 'commentsResponse',
      type: OperationType.request
    }, {
      name: 'completeTask',
      type: OperationType.action
    }],
    elseOperations: [{
      name: 'completeTask',
      type: OperationType.action
    }],
    type: OperationType.conditional,
  }],
  elseOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'getLocalization',
    args: ['actionName'],
    type: OperationType.addOperationData
  }, {
    name: 'promoteWarning',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const completeTask: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      bind: {
        url: '{completeSupplierURL}',
        params: '{completeParams}'
      },
      method: 'post'
    }
  },
  mappingName: 'responseData',
  type: OperationType.request,
}, {
  condition: `!!_.get({responseData}, "response.data.errors")`,
  conditionOperations: [{
    condition: `_.get({responseData},"response.data.errors[0].errorCode") === "REST.ERR.ACTION.INCOMPLETE"`,
    conditionOperations: [{
      name: 'incompleteFileUploadWarning',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    elseOperations: [{
      name: 'handleRequestException',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          url: '{completeSupplierURL}',
        },
        afterPingFinishAction: 'proceedWithTaskCompletion',
        method: 'post'
      }
    },
    type: OperationType.data
  }, {
    persistent: ['afterPingFinishAction'],
    type: OperationType.addPersistentData
  }, {
    name: 'pingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}]

export const proceedWithTaskCompletion: Action = [{
  moduleName: 'ToastNotifications',
  name: 'createCompleteNotifications',
  args: ['responseData']
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  moduleName: 'ToastNotifications',
  name: 'runStackedNotifications'
}, {
  persistent: [
    'actionName',
    'submissionData',
    'selectAll',
    'mandatoryCompleteParams',
    'endpointPrefix',
    'completeSupplierURL',
    'executionModuleName',
    'promoteFilesAction',
    'gsSaveRequestData'
  ],
  type: OperationType.removePersistentData
}, {
  condition: '{closeUploadReportDialog}',
  conditionOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }, {
    persistent: ['closeUploadReportDialog'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
}];

export const completeConfirmationWarning: Action = [{
    persistent: ['submissionData'],
    type: OperationType.addPersistentData
  }, {
    items: [{
      btnName: 'completeConfirmation.selectFiles',
      operations: [{
        name: 'switchToFilesTab',
        type: OperationType.action
      }, {
        persistent: ['submissionData'],
        type: OperationType.removePersistentData
      }],
      btnConfig: {
        pos: Position.start,
        themeColor: 'primary'
      }
    }, {
      btnName: 'completeConfirmation.cancel',
      operations: [],
      btnConfig: {
        pos: Position.end,
        fillMode: 'flat',
      }
    }, {
      btnName: 'completeConfirmation.completeAll',
      close: false,
      operations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        data: {
          template: {
            actionName: 'promote',
            ignoreAdditionalValidation: true,
            skipClaimedCondition: true,//if action comes from complete (context menu/action bar and action column) complete works for everything that can be completed
            executionModuleName: 'ActionExecutor',
            promoteFilesAction: 'completeActionWarnings',
            endpointPrefix: 'SUPPLIER_COMPLETE_',
            bind: {
              completeSupplierURL: `'/jobPhases/'+{submissionData.taskId}+'/complete'`
            }
          }
        },
        name: 'task_complete_jobPhase_files',
        type: OperationType.action
      }],
      btnConfig: {
        pos: Position.end,
        themeColor: 'primary'
      }
    }, {
      btnName: 'ESCAPE',
      operations: [{
        persistent: ['submissionData'],
        type: OperationType.removePersistentData
      }]
    }],
    placeholders: {
      className: 'tp-text-semibold'
    },
    text: 'completeConfirmation.text',
    title: 'completeConfirmation.title',
    className: 'sm complete-confirmation-warning',
    type: OperationType.dialog
  }]
;

export const switchToFilesTab: Action = [{
  data: {
    filesInView: true,
    forceOpenDrawer: true,
    quotesInView: false,
    template: {
      bind: {
        selectedSubmissions: '[{submissionData}]'
      }
    }
  },
  executeType: 'visible',
  moduleName: 'TaskList',
  name: 'gridOnSelectionChange',
  args: ['selectedSubmissions', 'forceOpenDrawer', 'quotesInView', 'filesInView']
}];
